export default __webpack_public_path__ + "static/cardImg1-2d73b71456afb287f6d6387e4456a126.webp";